<script lang="ts" setup>
import PaymentInlinePanelDefault from './PaymentInlinePanel.default.vue'
import PaymentInlinePanelNovelarc from './PaymentInlinePanel.novelarc.vue'
import PaymentInlinePanelFlipnovel from './PaymentInlinePanel.flipnovel.vue'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

withDefaults(defineProps<{
  contentId: string
  contentChapterId: string
  bookName?: string
  chapterName?: string
  serialStatus?: number
  dark?: boolean
  markRecommendOnPay?: boolean
}>(), {
  bookName: '',
  chapterName: '',
  serialStatus: 0,
  markRecommendOnPay: true,
})

const emit = defineEmits<{
  (e: 'success'): void
  (e: 'update:membership-only', val: boolean): void
}>()

const PaymentInlinePanelComponent = loadBrandComponent({
  rocnovel: PaymentInlinePanelDefault,
  oceread: PaymentInlinePanelDefault,
  talewave: PaymentInlinePanelDefault,
  ficmoon: PaymentInlinePanelDefault,
  novelarc: PaymentInlinePanelNovelarc,
  storyella: PaymentInlinePanelNovelarc,
  aurenovel: PaymentInlinePanelNovelarc,
  silktale: PaymentInlinePanelNovelarc,
  pearla: PaymentInlinePanelNovelarc,
  fictora: PaymentInlinePanelDefault,
  marinovel: PaymentInlinePanelDefault,
  flipnovel: PaymentInlinePanelFlipnovel,
  moonpage: PaymentInlinePanelDefault,
  storlyn: PaymentInlinePanelDefault,
  novaris: PaymentInlinePanelDefault,
})
</script>

<template>
  <PaymentInlinePanelComponent
    :content-id="contentId"
    :content-chapter-id="contentChapterId"
    :book-name="bookName"
    :chapter-name="chapterName"
    :serial-status="serialStatus"
    :dark="dark"
    :mark-recommend-on-pay="markRecommendOnPay"
    @success="emit('success')"
    @update:membership-only="val => emit('update:membership-only', val)"
  />
</template>
